var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNounShopOwner3004489(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    stroke: "currentColor",
    fill: "currentColor",
    height: "1em",
    width: "1em",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.1,33.2l-4.9-22c-0.3-1.2-1.4-2.1-2.6-2.1h-65c-1.3,0-2.4,0.9-2.6,2.1l-5,22c0,0.2-0.1,0.4-0.1,0.6v54.3  c0,1.5,1.2,2.7,2.7,2.7h45.7h19.8h9.4c1.5,0,2.7-1.2,2.7-2.7V33.8C90.1,33.6,90.1,33.4,90.1,33.2z M84.6,36.5  c-0.6,3.3-3.3,5.7-6.5,5.7s-5.9-2.5-6.5-5.7H84.6z M80.3,14.6L84,31.1H71l-2.6-16.5H80.3z M52.7,14.6H63l2.6,16.5H52.7V14.6z   M65.9,36.5c-0.6,3.3-3.3,5.7-6.5,5.7s-5.9-2.5-6.5-5.7H65.9z M37,14.6h10.2v16.5H34.4L37,14.6z M47.2,36.5  c-0.6,3.3-3.3,5.7-6.5,5.7s-5.9-2.5-6.5-5.7H47.2z M19.6,14.6h11.9L29,31.1H16L19.6,14.6z M28.4,36.5c-0.6,3.3-3.3,5.7-6.5,5.7  s-5.9-2.5-6.5-5.7H28.4z M85.1,85.4h-1.9h-2.4h-5.4H61h-5.4h-2.9H15.3V45.5c1.9,1.3,4.2,2.1,6.7,2.1c3.8,0,7.1-1.8,9.4-4.7  c2.2,2.8,5.6,4.7,9.4,4.7s7.1-1.8,9.4-4.7c2.2,2.8,5.6,4.7,9.4,4.7c3.8,0,7.1-1.8,9.4-4.7c2.2,2.8,5.6,4.7,9.4,4.7  c2.5,0,4.7-0.8,6.7-2.1V85.4z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 56.9,
    rx: 9.3,
    ry: 10.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3,83.4C65.6,75,58.6,68.4,50,68.4S34.4,75,33.7,83.4H66.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounShopOwner3004489);
export default __webpack_public_path__ + "static/media/noun-shop-owner-3004489.f3c930960e295bbdf19453c1070fadc8.svg";
export { ForwardRef as ReactComponent };